import React from 'react';
import content from '../content';

import { FooterWrapper } from './styles/FooterStyles';

const Banner = () => {
  const { footer: { email }} = content;
  
  return <FooterWrapper>
    <div className="inner">
      <header className="major">
        <h2>{email}</h2>
      </header>
    </div>
  </FooterWrapper>
  
};

export default Banner;